import React, { useState, useEffect } from "react";
import { graphql, useStaticQuery } from "gatsby";
import NavCard from "./nav_card";
import useWindowDimensions from "../useWindowDimensions";
// import ContextConsumer from "../context"
import chevLeft from "../../images/chevron-left-light.svg";
import chevRight from "../../images/chevron-right-light.svg";

const SliderNav = ({
  cardClickHandler,
  slideIndex,
  slideView,
  toggleView
}) => {
  const data = useStaticQuery(graphql`
  {

    image2: file(name: {eq: "pjm-speaker"}, relativeDirectory: {eq: ""}) {
      childImageSharp {
        fluid(quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    },

    bgGreen: file(name: {eq: "QuoteStrips_cyan"}, relativeDirectory: {eq: ""}) {
      childImageSharp {
        fluid(quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    },

    vols: file(name: {eq: "Volunteer_01"}, relativeDirectory: {eq: ""}) {
      childImageSharp {
        fluid(quality: 100) {
          ...GatsbyImageSharpFluid
        }
      }
    },

    site {
      siteMetadata {
        menuLinks {
          link
          name
          name2
          color
        }
      }
    },

    mobileHeroImages: allFile(filter: {relativeDirectory: {eq: "heros"}}, sort: {fields: name}) {
      edges {
        node {
          childImageSharp {
            fluid(maxWidth: 1024) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
    
  }
  `)

  const [navLeft, setNavLeft] = useState({left: 0});
  const [leftToggleHide, setLeftToggleHide] = useState(false);
  const [rightToggleHide, setRightToggleHide] = useState(false);
  const [flag, setFlag] = useState(true);
  const {height, width} = useWindowDimensions();
  const [internalSlideView, setSlideView] = useState(slideView)

  function initLeft() {
    let leftVal = navLeft.left;
    const navCtrlOffsetWidth = 0;
    const navCardOffsetWidth = 130;
    const navSlideWidth = navCardOffsetWidth * 10 - 15;
    const availableWidth = width - navCtrlOffsetWidth * 2;
    const currPosOffset = slideIndex * navCardOffsetWidth;
    const widthOffset = availableWidth - navSlideWidth;
    const showingWidth = navSlideWidth - currPosOffset;

    if(availableWidth > showingWidth) {
      if (widthOffset > 0) {
        leftVal = (width - navSlideWidth) / 2;
      } else {
        leftVal = widthOffset + navCtrlOffsetWidth;
      }

    } else {
      leftVal = navCtrlOffsetWidth - currPosOffset + 60;
    }
    setNavLeft({ left: leftVal });
    setFlag(false);
  }

  useEffect(()=>{
    // console.log(`internalSlideView: `,internalSlideView)
  }, [internalSlideView])
  useEffect(() => {
    const sliderNav = document.querySelector('#slider-nav').clientWidth;
    if(flag) {
      initLeft();
    }

    if(navLeft.left > 0 && leftToggleHide === false) {
      setLeftToggleHide(true);
    } else {
      setLeftToggleHide(false);
    }

    if(rightToggleHide === false && width > (navLeft.left + sliderNav)) {
      setRightToggleHide(true);
    } else {
      setRightToggleHide(false);
    }
  }, [navLeft.left]);

  function slideNavLeft() {
    const newLeftVal = navLeft.left + 130;
    setNavLeft({ left: newLeftVal });
  }
  function slideNavRight() {
    const newLeftVal = navLeft.left - 130;
    setNavLeft({ left: newLeftVal });
  }

  let mobileChecker = width < 642 || (height < 600 && width < 642) || ((height / width < .7) && height < 600);
  console.log(height, width, height / width, mobileChecker);

  return (
    <div>
      <div className={leftToggleHide ? "control-left hide" : "control-left"} onClick={slideNavLeft}><img width="20" src={chevLeft} /></div>
      <div data-mob={mobileChecker} id="slider-nav" style={{left: !mobileChecker ? navLeft.left + "px":null}} className={slideView?"single":"hero"}>
        
        {data.site.siteMetadata.menuLinks.map((menuLinkObj, i) => (
          <NavCard
            appWidth={width}
            appHeight={height}
            key={i}
            name={menuLinkObj.name}
            name2={menuLinkObj.name2}
            link={menuLinkObj.link}
            toggleView={toggleView}
            slideIndex={slideIndex}
            number={i + 1}
            heroImageFluid={data.mobileHeroImages.edges[i + 1].node.childImageSharp.fluid}
            color={menuLinkObj.color}
          />
        ))}
       
      </div>
      <div className={rightToggleHide ? "control-right hide" : "control-right"} onClick={slideNavRight}><img width="20" src={chevRight} /></div>
    </div>
      
  )
}
export default SliderNav
